import { initials, avatarColor } from "@/lib/format";

export function Avatar({ name, size = 40, seed }) {
    const s = seed || name || "?";
    return (
        <div
            className="flex items-center justify-center rounded-lg font-medium text-white shrink-0 select-none"
            style={{ width: size, height: size, background: avatarColor(s), fontSize: size * 0.4 }}
            aria-hidden="true"
        >
            {initials(name)}
        </div>
    );
}
